import React, { Component } from 'react';
import axios from 'axios'
import { toCurrency, pythonApiIp, serverIp, firebaseAuth, PAYMENT_TYPE_STOCK } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants';
import { StockPaymentTablePython } from './StockPaymentTable';
import GroupPayment from './GroupPayment';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import { Form, Button,  Divider} from 'semantic-ui-react'


class StockPayment_pythonApi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: '',
            user: '',
            itemArray: [],
            grandTotal: 0,
            expenseAccountTotal: 0,
            itemsToPay: [],
            stockTotalOwed: 0
            //loading:true,
        }
    }

    componentDidMount() {
        console.log("++++++++: componentDidMount");
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            if (user) {
                console.log("mdx1 user exists..");
                // let isAnonymous = user.isAnonymous;
                let uid = user.uid;
                console.log("mdx12 uid:" + uid)
                console.log("mdx121 uid:" + user.email)

                if (user) {
                    console.log("maddx241 user is:" + user.email);

                    if (user.email) {
                        console.log("addx290 user.email  is:" + user.email);
                        this.setState({
                            user: user
                        })

                        //CHECK ALGOLIA FOR USER
                        checkAdminEmail(user.email, this.setAdminResult)
                    }

                } else {
                    console.log("rlx121 user NOT found");
                    this.setState({
                        authed: false,
                        // loading: false,
                        user: user,
                        uid: user.uid
                    })
                }

            } else {
                console.log("px13 user DOES NOT exist..");
                this.setState({
                    authed: false,
                    loading: false
                })
            }
        })
        // this.getDeliveredStockPayments();


    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //  console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.isAdmin) {

            if(this.props.type == 'stockPayments'){
                this.getStockItemsToPay();
            }else if(this.props.type == 'printingCharges'){
                this.getPrintingItemsToPay();
            }else{
                alert("No payment type sent")
            }
           
        }
    }
    
    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    getStockItemsToPay = () => {
        console.log("++++++++:getStockItemsToPay");


        this.setState({ loading: true, });

        axios.post(pythonApiIp + 'getStockItemsToPay', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log("dud1:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    this.setState({
                        loading: false,
                        expenseAccountTotal: response.data.expenseAccountTotal,
                       // itemsToPay: response.data.itemsToPay,
                        stockTotalOwed: response.data.stockTotalOwed
                    });


                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }



    getPrintingItemsToPay = () => {
        console.log("++++++++:getPrintingItemsToPay");


        this.setState({ loading: true, });

        axios.post(pythonApiIp + 'getPrintingItemsToPay', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log("dud1:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    this.setState({
                        loading: false,
                        expenseAccountTotal: response.data.expenseAccountTotal,
                       // itemsToPay: response.data.itemsToPay,
                        stockTotalOwed: response.data.stockTotalOwed
                    });


                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    payAmountToGroup = () => {
        console.log("++++++++:payAmountToGroup");

        this.setState({ loading: true, });

        axios.post(pythonApiIp + 'payAmountToGroup', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email,
            groupToPay: this.props.type,
            amount: parseInt(this.state.amount)
        })
            .then((response) => {
                console.log("dud1:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    this.setState({
                        loading: false,
                        amount: ''
                    });

                    alert(response.data.message);
                    //this.getStockItemsToPay();

                    if(this.props.type == 'stockPayments'){
                        this.getStockItemsToPay();
                    }else if(this.props.type == 'printingCharges'){
                        this.getPrintingItemsToPay();
                    }else{
                        alert("No payment type sent")
                    }

                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    render() {

        // const itemTotals = this.state.itemArray.length > 0
        //     ? this.state.itemArray.map((item) => <GroupPayment item={item} user={this.state.user} paymentType={PAYMENT_TYPE_STOCK} />)
        //     : ''

        const orderTableStock = this.state.itemsToPay.length > 0
            ? <StockPaymentTablePython
                orders={this.state.itemsToPay}
                reloadOrders={this.getStockItemsToPay}
                user={this.state.user} />
            : ""

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        const payAmountForm = <Form onSubmit={this.payAmountToGroup}>
            {/* QTY */}
            <Form.Field>
                <label>Qty: {toCurrency(this.state.amount)} </label>
                <Form.Input
                    fluid
                    name={'amount'}
                    value={this.state.amount}
                    icon='add user'
                    iconPosition='left'
                    placeholder='Amount to Pay'
                    onChange={this.handleTextInputChange}
                    type='number'
                />
            </Form.Field>
            <Button> PAY AMOUNT </Button>
        </Form>

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.stockPayment
            ? <div>
                <Divider horizontal>{this.props.type}</Divider>
                <h1>Total Stock Amount Owed:{toCurrency(this.state.stockTotalOwed)}</h1>
                <h3>NUM ORDERS:{this.state.itemsToPay.length}</h3>
                <h3>Expense Account Total:{toCurrency(this.state.expenseAccountTotal)}</h3>
                <br />
                {payAmountForm}
                {/* {itemTotals} */}
                {orderTableStock}

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :

                <div>

                    {wholeUI}
                </div>
        )
    }
}

export default StockPayment_pythonApi;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/StockPayment_pythonApi.js